<template>
  <div class="d-flex px-5 py-3 container justify-content-center flex-column">
    <div v-if="complete" class="d-flex gap-50">
      <div class="bg-white p-3 w-25">
        <img :src="this.dataSet1.uri" class="img-fluid m-0 diff-img">
      </div>
      <meta-data-table v-if="currentJob.state === 'completed'" :first-file="currentJob.apiJob?.input[0]"
                       :second-file="currentJob.apiJob?.input[1]"></meta-data-table>
    </div>
    <div v-if="this.factors !== null" class="mt-3">
      <ImageQualityFactorTable :percentDiff="percentDiff" :factors="this.factors" :response="this.response"/>
    </div>
  </div>
</template>
<script>
import store from './../../../mixins/store.mixin'
import currentJob from './../../../mixins/current_job.mixin'
import ViewJson from "../../Viewer/Json/ViewJson.vue";
import MetaDataTable from "../../Viewer/Compare/MetaDataTable.vue";
import VideoQualityFactorTable from "../../../../resultdisplay/VideoQualityFactorTable.vue";
import {EventBus} from "../../../events/event.bus";
import {EVENT_JOB_COMPLETE} from "../../../events/job.events";
import axios from 'axios';
import ImageQualityFactorTable from "../../../../resultdisplay/ImageQualityFactorTable.vue";

export default {
  name: "OutputCompareVideo",
  props: {},
  components: {ImageQualityFactorTable, VideoQualityFactorTable, MetaDataTable, ViewJson},
  mixins: [
    store,
    currentJob
  ],
  data() {
    return {
      metrics: null,
      factors: null,
      response: null,
      dataSet0:{},
      dataSet1:{}
    };
  },
  mounted: function () {
  },
  created: function () {
    EventBus.$on(EVENT_JOB_COMPLETE, (data) => {
      this.currentJob.apiJob.output.map((data) => {
          if (data.content_type === 'application/json') {
            this.dataSet0 = data;
          } else {
              this.dataSet1 = data;
          }
      });
      axios.get(this.dataSet0.uri).then((response) => {
        this.response = response.data;
        this.factors = Object.values(this.response)[1];

      });
    });
  },
  methods: {},
  computed: {
    percentDiff() {
      if (this.currentJob.state !== 'completed' && this.factors === null) {
        return 0;
      }

      let totalPixel = 0;
      let firstFileTotalPx = this.currentJob.apiJob?.input[0].metadata.image_height * this.currentJob.apiJob?.input[0].metadata.image_width;
      let secondFileTotalPx = this.currentJob.apiJob?.input[1].metadata.image_height * this.currentJob.apiJob?.input[1].metadata.image_width;

      //TODO: For now, we use the file with the highest pixel fast total pixel
      if (firstFileTotalPx > secondFileTotalPx) {
        totalPixel = firstFileTotalPx;
      } else {
        totalPixel = secondFileTotalPx;
      }
      return ((this.factors.all / totalPixel) * 100).toFixed(2);
    },
  }
};
</script>
<style lang="scss" scoped>
</style>
